import { useMediaQuery, useTheme } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../../components/exports";
import { DialogContext } from "../../contexts/DialogueContext";
import { fetchProjectDetail } from "../../slices/ProjectDetailSlice";
import { setProjectDetailIndex } from "../../slices/SharedSlice";
import { RootState } from "../../slices/Store";
import ProjectDetailDesktopDialog from "./Desktop/ProjectDetailDesktopDialog";
import ProjectDetailMobileDialog from "./Mobile/ProjectDetailMobileDialog";

export default function ProjectDetailDialog(props: {
    index?: number;
    projectHashId: string;
    requirementId?: number;
    selectedFollowUpId?: number;
    openSales?: boolean;
    openFollowUps?: boolean;
    openNotes?: boolean;
}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isFetching, setIsFetching] = useState(true);
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"), {
        defaultMatches: null,
    });

    const { closeDialog } = useContext(DialogContext);

    useEffect(() => {
        if (props.index >= 0) {
            dispatch(setProjectDetailIndex(props.index));
        } else {
            dispatch(setProjectDetailIndex(-1));
        }

        navigate(`#${props.projectHashId}`);

        fetchProjectDetail(
            projectDetailState,
            props.projectHashId,
            props.requirementId,
            dispatch,
            (result) => {
                setIsFetching(false);
                if (!result) {
                    closeDialog();
                }
            }
        );

        return () => {
            navigate(`#`);
        };
    }, []);

    if (
        isFetching ||
        projectDetailState.fetchingProjectDetail ||
        isLargeScreen === null
    ) {
        return <Spinner />;
    }

    return isLargeScreen ? (
        <ProjectDetailDesktopDialog
            selectedFollowUpId={props.selectedFollowUpId}
            openFollowUps={props.openFollowUps}
            openSales={props.openSales}
            openNotes={props.openNotes}
        />
    ) : (
        <ProjectDetailMobileDialog
            selectedFollowUpId={props.selectedFollowUpId}
            openSales={props.openSales}
        />
    );
}
